export class SC_LocType {
    static readonly NULL = 0;
    static readonly INDOOR_MALL = 1;
    static readonly OUTDOOR_MALL = 2;
    static readonly STREET_STORE = 4;

    constructor(private type: number = SC_LocType.NULL) { }

    static fromAPI(apiValue: number): SC_LocType {
        switch (apiValue) {
            case SC_LocType.INDOOR_MALL:
                return new SC_LocType(SC_LocType.INDOOR_MALL);
            case SC_LocType.OUTDOOR_MALL:
                return new SC_LocType(SC_LocType.OUTDOOR_MALL);
            case SC_LocType.STREET_STORE:
                return new SC_LocType(SC_LocType.STREET_STORE);
            default:
                return new SC_LocType();
        }
    }

    is(type: number): boolean {
        return this.type === type;
    }

    toAPI(): number {
        return this.type;
    }

    clone(): SC_LocType {
        return new SC_LocType(this.type);
    }

    /**
     * Merges another SC_LocType object into this one, replacing null fields
     */
    merge(other: SC_LocType): SC_LocType {
        if (other.type !== SC_LocType.NULL) {
            this.type = other.type;
        }

        return this;
    }

    static readonly types = [
        { key: SC_LocType.NULL, display: "Not Set" },
        { key: SC_LocType.INDOOR_MALL, display: "Indoor Mall" },
        { key: SC_LocType.OUTDOOR_MALL, display: "Outdoor Mall" },
        { key: SC_LocType.STREET_STORE, display: "Street Store" },
    ];

    toString(): string {
        switch (this.type) {
            case SC_LocType.STREET_STORE:
                return "Street Store";
            case SC_LocType.OUTDOOR_MALL:
                return "Outdoor Mall";
            case SC_LocType.INDOOR_MALL:
                return "Indoor Mall";
            default:
                return "Not Set";
        }
    }
}
